export default __webpack_public_path__ + "static/media/congo_fill.9b2e6c94.svg";